import { render, staticRenderFns } from "./TablesMaterials.vue?vue&type=template&id=759ea529&"
import script from "./TablesMaterials.vue?vue&type=script&lang=js&"
export * from "./TablesMaterials.vue?vue&type=script&lang=js&"
import style0 from "./TablesMaterials.vue?vue&type=style&index=0&id=759ea529&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports